import { getTheme } from "@clipboard-health/ui-theme";
import { ThemeProvider } from "@mui/material";
import { useSearchParams } from "@src/appV2/lib/utils/useSearchParams";
import { type ShiftDiscoverySearchMode } from "@src/appV2/OpenShifts/ShiftAction/api/useClaimShift";

import {
  DEFAULT_SHIFT_DISCOVERY_SEARCH_MODE,
  getBaseModalsNavigationPath,
} from "../ShiftDiscovery/getBaseModalsNavigationPath";
import { ShiftModalsDataProvider } from "../ShiftDiscovery/useShiftModalsDataContext";
import { BackgroundChecksRouter } from "./BackgroundChecksRouter";
import { SEARCH_MODE_QUERY_PARAM_KEY } from "./constants";

export function BackgroundCheckContainer() {
  const queryParams = useSearchParams<{
    [SEARCH_MODE_QUERY_PARAM_KEY]: ShiftDiscoverySearchMode | undefined;
  }>();

  const searchMode = queryParams[SEARCH_MODE_QUERY_PARAM_KEY];
  const baseModalsNavigationPath = getBaseModalsNavigationPath(searchMode);

  return (
    <ThemeProvider theme={getTheme()}>
      <ShiftModalsDataProvider
        baseNavigationPath={baseModalsNavigationPath}
        searchMode={searchMode ?? DEFAULT_SHIFT_DISCOVERY_SEARCH_MODE}
      >
        <BackgroundChecksRouter />
      </ShiftModalsDataProvider>
    </ThemeProvider>
  );
}
